"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
export function useParallax(t0) {
  const $ = _c(5);
  const speed = t0 === undefined ? 0.5 : t0;
  const [offsetY, setOffsetY] = useState(0);
  const ref = useRef(null);
  let t1;
  let t2;
  if ($[0] !== speed) {
    t1 = () => {
      const handleScroll = () => {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          const scrollPosition = window.scrollY;
          const elementTop = rect.top + scrollPosition;
          const offset = (scrollPosition - elementTop) * speed;
          setOffsetY(offset);
        }
      };
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    t2 = [speed];
    $[0] = speed;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== offsetY) {
    t3 = {
      ref,
      offsetY
    };
    $[3] = offsetY;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}